const companyLangs = {
  companyList: {
    title: "Danh sách công ty",
  },
  companyDetail: {
    title: "Thông tin công ty: {{name}}",
  },
  companyAdd: {
    title: "Thêm công ty",
  },
  companyUpdate: {
    title: "Cập nhật công ty",
  },
  form: {
    company_name: "Tên công ty",
    tax: "Mã số thuế",
    email: "Email",
    emailAccount: "Email kế toán",
    phone: "Điện thoại",
    address: "Địa chỉ",
    ward: "Phường",
    district: "Quận",
    city: "Thành phố",
    notCity: "Ngoại thành",
  },
  success: {
    companyAdd: "Thêm công ty thành công",
    companyUpdate: "Cập nhật công ty thành công",
  },
  error: {
    companyList: "lấy danh sách công ty lỗi",
    companyAdd: "Thêm công ty lỗi",
    companyUpdate: "Cập nhật công ty lỗi",
  },
};

export default companyLangs;
